<template>
  <div class="cat-block cat-block-margin">
    <div class="cat-title">
      {{category.name}} <tool-tip :index="catIndex"></tool-tip>
    </div>
    <div class="subcat-col">
      <subcat-block v-for="subcategory in category.subcategories" 
        :key="subcategory.name" 
        :subcategory="subcategory">
      </subcat-block>
    </div>
  </div>
</template>

<script>
import LegendSubcatBlock from './LegendSubcatBlock';
import ToolTip from '../ToolTip';

export default {
  name: 'catblock',
  props: ['category', 'catIndex'],
  components: {
    'subcat-block': LegendSubcatBlock,
    'tool-tip': ToolTip,
  },
};
</script>

<style lang="less">

  .cat-block:last-child {
    border-bottom: none;
  }

  .cat-title {
    font-weight: bold;
    line-height: 1;
    padding-top: 5px;
    height: 26px;
  }
  .subcat-col {
    text-align: left;
  }

  .first-category-title {
    height: 66px;
    padding-top: 47px;
  }
</style>




// WEBPACK FOOTER //
// LegendCatBlock.vue?1e16ad5c